import i18n, { type TFunction } from 'i18next';
import { devLog } from '../utils';
import { ApryseSDK } from '../pdf/ApryseSDK';

export const defaultLanguage = 'en';
export const supportedLanguages = [defaultLanguage, 'de'];

/**
 * Initializes the i18next instance with the resources of the given language.
 * @param language Any supported language. Currently `de-DE` or `en-US`.
 */
export default function initI18n(language: string): Promise<TFunction> {
    language = language?.substring(0, 2)?.toLowerCase();

    if (!supportedLanguages.includes(language)) {
        console.warn(`Unsupported language "${language}". Default language (${defaultLanguage}) will be used...`);
        language = defaultLanguage;
    }

    i18n.on('languageChanged', newLanguage => {
        devLog(`[i18next] language changed: "${newLanguage}"`);
        ApryseSDK.setLanguage(language);
    });

    return Promise.all(
        supportedLanguages
            .map(lang => [import(`./${lang}/viewer_.json`), import(`./${lang}/ui.json`)])
            .flat(),
    ).then(languageFiles => {
        const resources = {};

        supportedLanguages
            .map(lang => {
                resources[lang] = {};
                return [lang, lang];
            })
            .flat()
            .forEach((lang, i) => {
                if (i % 2 === 0) {
                    resources[lang]['viewer_'] = languageFiles[i];
                } else {
                    resources[lang]['ui'] = languageFiles[i];
                }
            });

        return i18n.init({
            compatibilityJSON: 'v3',
            defaultNS: 'ui',
            nsSeparator: ':', // namespace separator
            keySeparator: '.', // key separator
            ns: ['viewer_', 'ui'],
            supportedLngs: supportedLanguages,
            lng: language,
            fallbackLng: defaultLanguage,
            resources,
        });
    });
}
